import React from 'react'
import { AppBar, Box, Grid, Link, Stack, Toolbar } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import { HeaderUserControls, MobileMenuIcon, ThemeSwitch } from '../../components'
import { Icon } from '../../components'
import { APP_ROUTES, COMPANY_PHONES, CONTENT_WRAPPER_SX_PC } from '../../constants.ts'
import { useUser } from '@/stores/slices/user-slice.ts'

export const HeaderPcFormat = (): React.ReactElement => {
  const user = useUser()

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          color: 'linkPageText.active',
          py: 0,
          backgroundColor: 'background.footer',
        }}
      >
        <Toolbar disableGutters>
          <Stack
            justifyContent="space-between"
            alignItems="center"
            direction="row"
            sx={{
              width: '100vw',
            }}
          >
            <Box sx={{ width: '300px', padding: '0 0 0 26px' }}>
              <Link component={RouterLink} to={user ? APP_ROUTES.SbpPayments : APP_ROUTES.Login}>
                <Icon name={'CifraBankLightIcon'} size="initial" />
              </Link>
            </Box>
            <Box
              sx={{
                width: 'calc(100vw - 300px)',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  ...CONTENT_WRAPPER_SX_PC,
                  flexDirection: 'row',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  gap: '12px',
                  mt: 0,
                }}
              >
                <Grid item sx={{ display: { xs: 'none', md: 'initial' } }}>
                  <Link variant="h6" href={`tel:${COMPANY_PHONES[0]}`} color="inherit">
                    {COMPANY_PHONES[0]}
                  </Link>
                </Grid>
                <Grid item sx={{ display: { md: 'none' } }}>
                  <MobileMenuIcon />
                </Grid>
                <HeaderUserControls />
                <Grid item>
                  <ThemeSwitch />
                </Grid>
              </Box>
            </Box>
          </Stack>
        </Toolbar>
      </AppBar>
    </>
  )
}
